export default __webpack_public_path__ + "static/media/top_design.0180759a.png";